import { TOTAL_DAYS } from "../data";

interface ProgressBarProps {
  currentDay: number;
  stepInDay: number;
  stepsInDay: number;
}

/** 7-day progress indicator with per-day segments. */
export function ProgressBar({ currentDay, stepInDay, stepsInDay }: ProgressBarProps) {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-semibold text-muted-foreground">
          Day {currentDay} of {TOTAL_DAYS}
        </span>
        <span className="text-xs text-muted-foreground">
          Decision {stepInDay}/{stepsInDay}
        </span>
      </div>
      <div className="flex gap-1.5" role="progressbar" aria-valuemin={1} aria-valuemax={TOTAL_DAYS} aria-valuenow={currentDay}>
        {Array.from({ length: TOTAL_DAYS }, (_, i) => {
          const day = i + 1;
          const isPast = day < currentDay;
          const isCurrent = day === currentDay;
          return (
            <div key={day} className="flex-1">
              <div
                className={`h-2.5 rounded-full transition-colors ${
                  isPast
                    ? "bg-primary"
                    : isCurrent
                      ? "bg-primary/40"
                      : "bg-muted"
                }`}
              >
                {isCurrent && (
                  <div
                    className="h-full rounded-full bg-primary transition-all duration-300"
                    style={{ width: `${(stepInDay / stepsInDay) * 100}%` }}
                  />
                )}
              </div>
              <div
                className={`mt-1 text-center text-[10px] font-medium ${
                  isCurrent ? "text-primary" : "text-muted-foreground/60"
                }`}
              >
                {day}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
